import { generatePath, Link } from "react-router";

import type { SnackList_SnackListPageQuery } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { Button } from "@/components/ui/button/button";
import { ExternalLink } from "@/components/ui/button/external-link";

import { DesignSnackList } from "./list";
import { DesignSnackHeaderAndTab } from "../../../_shared/ui/header-and-tab";
import { useSnackDeleteMutation } from "../../model";

type Props = {
	hotelID: string;
	data: SnackList_SnackListPageQuery;
};

export const DesignSnackListPresenter = ({ hotelID, data }: Props) => {
	const { onDelete } = useSnackDeleteMutation({ hotelID });

	const createNewSnackPath = generatePath(PATHS.HOTEL.RESERVATION_PAGE.SNACK.EDIT.NEW, { hotelID });

	return (
		<FeatureIslandContainer>
			<DesignSnackHeaderAndTab title="スナックの一覧" hotelID={hotelID} />
			<div className="px-4 py-3 laptop:hidden laptop:px-12">
				<div className="rounded-md border border-zinc-200 bg-zinc-50 px-3 py-2 text-xs">
					スナックの設定はPC版からのみ変更できます
				</div>
			</div>
			<FeatureIslandMainWithBackGround islandTitle="スナック">
				<div className="pointer-events-none opacity-50 laptop:pointer-events-auto laptop:opacity-100">
					<div className="flex justify-end">
						<Link to={createNewSnackPath} viewTransition>
							<Button type="button" variant="default" size="xl">
								新規作成
							</Button>
						</Link>
					</div>

					<DesignSnackList hotelID={hotelID} data={data} onDelete={onDelete} />
				</div>
			</FeatureIslandMainWithBackGround>

			<FeatureIslandMainWithBackGround islandTitle="参考記事">
				<div className="flex flex-col items-start gap-y-0">
					<ExternalLink
						href="https://chillnn.notion.site/e8d889578b934d4799d0f2c84f5e3f60"
						text="スナックの作成方法"
					/>
					<ExternalLink
						href="https://chillnn.notion.site/LP-095f04cfaecc4e3a868d54d60b6a7103"
						text="カレンダーなしで表示する方法（LP用）"
					/>
					<ExternalLink
						href="https://chillnn.notion.site/119fffe15c578056ad00da95c584b2f4"
						text="よくある質問"
					/>
				</div>
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
};

DesignSnackListPresenter.displayName = "DesignSnackListPresenter";
